<template>
  <div class="onebox">
    <drag-modal :visible="$store.state.dislog.paymentPopUp" @cancel="reset" title='诉讼费用' :class='{ "editbox": Edit }'
      width='1053px'>
      <div class="navbox" v-if='Edit'>
        <!-- <Nscroll @getIndex='see' @delCopy='copydel' :openEdit='openEdit'></Nscroll> -->
        <div class="intopbtn" v-if='!isAllDis'>
          <a-button :icon="listStatus ? 'edit' : ''"
            v-if="$common.AccAUTH($store.state.cause.accuser.id, 'costs:edit') && showModify" style="margin-left:10px;"
            @click='setOpen'>{{ openEdit ? "修改" : "取消修改" }}</a-button>
          <!-- {{ !listStatus && openEdit ? "添加费用" : !listStatus && !openEdit ? "取消添加" : listStatus && openEdit ? "修改" : "取消修改" }} -->
        </div>
      </div>
      <a-spin :spinning="loading">
        <a-form-model ref="forms" :model="form" :rules="openEdit ? {} : rules" :label-col="{ span: 10 }"
          :wrapper-col="{ span: 24 }" class="rform">
          <!-- <div class="principal">本金：<span class="ninputs">{{ $store.state.cause.capital | showYuan }}</span></div> -->
          <div>
            <a-radio-group name="radioGroup" button-style="solid" v-model='form.type' @change="getphaseChange">
              <a-radio :value="1" style="font-size: 15px;">一审</a-radio>
              <a-radio :value="2" style="font-size: 15px;">二审</a-radio>
              <a-radio :value="3" style="font-size: 15px;">再审</a-radio>
              <a-radio :value="4" style="font-size: 15px;">执行</a-radio>
            </a-radio-group>
            <div class="listcard" :class="{ 'listnone': form.supp.length == 0 && form.accept_file.length == 0 }"
              v-if="listStatus">
              <div class="licter" v-if="!openEdit">
                <label>补充材料:</label>
                <div class="rmain">
                  <a href="javascript:void(0);" @click='sAdd(1)'>电子</a>
                  <a href="javascript:void(0);" @click='sAdd(2)'>微信</a>
                  <a href="javascript:void(0);" @click='sAdd(3)'>现场</a>
                  <a href="javascript:void(0);" @click='sAdd(4)'>邮寄</a>
                </div>
              </div>
              <div class="ilikecon" v-if="form.supp.length > 0">
                <div class="ilikebox" v-for='(i, index1) in form.supp' :key='index1'>
                  <div class="likebox" v-if='i.type == 1'>
                    <div class="htit">补充材料：电子
                      <span @click='sdel(index1)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="平台名称" :prop="'supp.' + index1 + '.platform'"
                          :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                          <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index1 + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="补充时间" :prop="'supp.' + index1 + '.time'"
                          :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'supp.' + index1 + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 2'>
                    <div class="htit">补充材料：微信
                      <span @click='sdel(index1)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="对方微信号" :prop="'supp.' + index1 + '.wx'"
                          :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                          <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index1 + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="补充时间" :prop="'supp.' + index1 + '.time'"
                          :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'supp.' + index1 + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 3'>
                    <div class="htit">
                      补充材料：现场
                      <span @click='sdel(index1)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="补充提交人" :prop="'supp.' + index1 + '.submiter'"
                          :rules="{ required: true, message: '请输入补充提交人', trigger: 'blur' }">
                          <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入补充提交人" />
                        </a-form-model-item>
                      </a-col>

                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index1 + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="补充时间" :prop="'supp.' + index1 + '.time'"
                          :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'supp.' + index1 + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 4'>
                    <div class="htit">
                      补充材料：邮寄
                      <span @click='sdel(index1)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="单号" :prop="'supp.' + index1 + '.ship_no'"
                          :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                          <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="联系方式" :prop="'supp.' + index1 + '.tel'"
                          :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                          <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index1 + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="收件人" :prop="'supp.' + index1 + '.receive_name'"
                          :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                          <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入收件人" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="寄出时间" :prop="'supp.' + index1 + '.ship_time'"
                          :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                          <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="">
                          <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间:" : (i.gout == "b" ? "拒收时间:" : "无") }}</label>
                          <a-radio-group v-model='i.gout' :disabled='openEdit' style="white-space:nowrap;" size='small'
                            v-else>
                            <a-radio-button :value="null"
                              style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                            <a-radio-button :value="'a'"
                              style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                            <a-radio-button :value="'b'"
                              style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                          </a-radio-group>
                          <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                            :disabled='openEdit' style="width:100%;" />
                          <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" v-if='i.gout == "b"' />
                          <a-input disabled v-if='!i.gout' />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='12'>
                        <a-form-model-item label="收件地址" :prop="'supp.' + index1 + '.addr'"
                          :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                          <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='12'>
                        <a-form-model-item label="备注" :prop="'supp.' + index1 + '.comment'"
                          :rules="{ required: false, message: '请输入备注', trigger: 'blur' }">
                          <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
              <div class="licter" v-if='!openEdit'>
                <label>接收材料:</label>
                <div class="rmain">
                  <a href="javascript:void(0);" @click='sAdd(1, 1)'>电子</a>
                  <a href="javascript:void(0);" @click='sAdd(2, 1)'>微信</a>
                  <a href="javascript:void(0);" @click='sAdd(3, 1)'>现场</a>
                  <a href="javascript:void(0);" @click='sAdd(4, 1)'>邮寄</a>
                </div>
              </div>
              <div class="ilikecon" v-if="form.accept_file.length > 0">
                <div class="ilikebox" v-for='(i, index) in form.accept_file' :key='index'>
                  <div class="likebox" v-if='i.type == 1'>
                    <div class="htit">接收材料：电子
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'"
                          :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                          <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                          :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 2'>
                    <div class="htit">接收材料：微信
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'"
                          :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                          <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                          :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 3'>
                    <div class="htit">
                      接收材料：现场
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'"
                          :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                          <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入接收人" />
                        </a-form-model-item>
                      </a-col>

                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                          :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 4'>
                    <div class="htit">
                      接收材料：邮寄
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'"
                          :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                          <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'"
                          :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                          <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'"
                          :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                          <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入接收人" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'"
                          :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                          <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="">
                          <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间:" : (i.gout == "b" ? "拒收时间:" : "无") }}</label>
                          <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                            v-else>
                            <a-radio-button :value="null"
                              style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                            <a-radio-button :value="'a'"
                              style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                            <a-radio-button :value="'b'"
                              style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                          </a-radio-group>
                          <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                            :disabled='openEdit' style="width:100%;" />
                          <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" v-if='i.gout == "b"' />
                          <a-input disabled v-if='!i.gout' />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='12'>
                        <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'"
                          :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                          <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='12'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
              <!-- <div class="lawsuit" v-if="form.fee.length > 0 || form.refund_fee.length > 0">诉讼相关费用：</div> -->
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-col-1 ant-form-item-label" style="width:50px;text-align:left;"><label
                    title="诉讼相关费用">缴纳</label></div>
                <div class="ant-col ant-col-14 ant-form-item-control-wrapper" style="width:95%;">
                  <div style="display: flex;justify-content: space-between;">
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 1)'>诉讼费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 10)'>上诉费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 2)'>公告费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 3)'>保全费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 4)'>律师费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 5)'>差旅费</a-button>
                    <!-- <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 12)'>执行费</a-button> -->
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 13)'>评估费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("fee", 7)'>其他</a-button>
                  </div>
                </div>
              </div>
              <div class="fourlist">
                <div class="dul">
                  <div v-for='(i, index) in form.fee' :key='index' class="dil">
                    <div class="li" v-if='i.type == 1'>
                      <div class="input">
                        <a-form-model-item label='诉讼费' :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入诉讼费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入诉讼费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="缴费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.give_way'"
                          :rules="{ required: true, message: '请选择缴费类型', trigger: 'change' }">
                          <a-select v-model="i.give_way" placeholder="请选择缴费类型" :disabled='openEdit'>
                            <a-select-option :value="1">全缴</a-select-option>
                            <a-select-option :value="2">半缴</a-select-option>
                            <a-select-option :value="3">补缴</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 10'>
                      <div class="input">
                        <a-form-model-item label='上诉费' :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入上诉费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入上诉费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="缴费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.give_way'"
                          :rules="{ required: true, message: '请选择缴费类型', trigger: 'change' }">
                          <a-select v-model="i.give_way" placeholder="请选择缴费类型" :disabled='openEdit'>
                            <a-select-option :value="1">全缴</a-select-option>
                            <a-select-option :value="2">半缴</a-select-option>
                            <a-select-option :value="3">补缴</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 2'>
                      <div class="input">
                        <a-form-model-item label="公告费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入公告费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入公告费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="公告费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.notice_fee_way'"
                          :rules="{ required: true, message: '请选择公告费类型', trigger: 'change' }">
                          <a-select v-model="i.notice_fee_way" placeholder="请选择公告费类型" :disabled='openEdit'>
                            <a-select-option :value="1">开庭公告</a-select-option>
                            <a-select-option :value="2">判决公告</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 3'>
                      <div class="input">
                        <a-form-model-item label="保全费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入保全费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入保全费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.other_type'"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 4'>
                      <div class="input">
                        <a-form-model-item label="律师费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入律师费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入律师费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.other_type'"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 5'>
                      <div class="input">
                        <a-form-model-item label="差旅费" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入差旅费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入差旅费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 6'>
                      <div class="input">
                        <a-form-model-item label="退费" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入退费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 12'>
                      <!-- <div class="input">
                        <a-form-model-item label="执行费" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入执行费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入执行费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div> -->
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 13'>
                      <div class="input">
                        <a-form-model-item label="评估费" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入评估费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入评估费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 7'>
                      <div class="input">
                        <a-form-model-item label="其他" :label-col="{ span: 9 }" :prop="'fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入其他费用', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入其他费用' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :prop="'fee.' + index + '.other_type'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :prop="'fee.' + index + '.pay_way'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("fee", index)' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-col-1 ant-form-item-label" style="width:50px;text-align:left;"><label
                    title="诉讼相关费用">退回</label></div>
                <div class="ant-col ant-col-14 ant-form-item-control-wrapper" style="width:95%;">
                  <div style="display: flex;justify-content: space-between;">
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("refund_fee", 1)'>诉讼费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }"
                      @click='plusAdd("refund_fee", 10)'>上诉费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("refund_fee", 2)'>公告费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("refund_fee", 3)'>保全费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("refund_fee", 4)'>律师费</a-button>
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("refund_fee", 5)'>差旅费</a-button>
                    <!-- <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }"
                      @click='plusAdd("refund_fee", 12)'>执行费</a-button> -->
                    <a-button icon="plus" :disabled="openEdit" class="mr20"
                      :style="{ 'background': openEdit ? '#fff' : '' }"
                      @click='plusAdd("refund_fee", 13)'>评估费</a-button>
                    <a-button icon="plus" class="mr20" :disabled="openEdit"
                      :style="{ 'background': openEdit ? '#fff' : '' }" @click='plusAdd("refund_fee", 7)'>其他</a-button>
                  </div>
                </div>
              </div>
              <div class="fourlist">
                <div class="dul">
                  <div v-for='(i, index) in form.refund_fee' :key='index' class="dil">
                    <div class="li" v-if='i.type == 1'>
                      <div class="input">
                        <a-form-model-item label='诉讼费' :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入诉讼费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入诉讼费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="缴费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.give_way'"
                          :rules="{ required: true, message: '请选择缴费方式', trigger: 'change' }">
                          <a-select v-model="i.give_way" placeholder="请选择缴费类型" :disabled='openEdit'>
                            <a-select-option :value="1">全缴</a-select-option>
                            <a-select-option :value="2">半缴</a-select-option>
                            <a-select-option :value="3">补缴</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 10'>
                      <div class="input">
                        <a-form-model-item label='上诉费' :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入上诉费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入上诉费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="缴费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.give_way'"
                          :rules="{ required: true, message: '请选择缴费方式', trigger: 'change' }">
                          <a-select v-model="i.give_way" placeholder="请选择缴费类型" :disabled='openEdit'>
                            <a-select-option :value="1">全缴</a-select-option>
                            <a-select-option :value="2">半缴</a-select-option>
                            <a-select-option :value="3">补缴</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 2'>
                      <div class="input">
                        <a-form-model-item label="公告费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入公告费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入公告费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="公告费类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.notice_fee_way'"
                          :rules="{ required: true, message: '请选择公告费类型', trigger: 'change' }">
                          <a-select v-model="i.notice_fee_way" placeholder="请选择公告费类型" :disabled='openEdit'>
                            <a-select-option :value="1" v-if='form.type == 1'>开庭公告</a-select-option>
                            <a-select-option :value="2" v-if='form.type == 1'>判决公告</a-select-option>
                            <a-select-option :value="3" v-if='form.type == 2'>开庭公告</a-select-option>
                            <a-select-option :value="4" v-if='form.type == 2'>判决公告</a-select-option>
                            <!-- <a-select-option :value="5" v-if='step == 112'>开庭公告 </a-select-option>
                            <a-select-option :value="6" v-if='step == 112'>判决公告</a-select-option> -->
                            <a-select-option :value="7" v-if='form.type == 3'>开庭公告 </a-select-option>
                            <a-select-option :value="8" v-if='form.type == 3'>判决公告</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 3'>
                      <div class="input">
                        <a-form-model-item label="保全费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入保全费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入保全费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.other_type'"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 4'>
                      <div class="input">
                        <a-form-model-item label="律师费" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.fee'" :rules="[{ required: true, message: '请输入律师费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入律师费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.other_type'"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.pay_way'"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :wrapper-col="{ span: 14 }"
                          :prop="'refund_fee.' + index + '.time'"
                          :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 5'>
                      <div class="input">
                        <a-form-model-item label="差旅费" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入差旅费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入差旅费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.other_type'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.pay_way'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 6'>
                      <div class="input">
                        <a-form-model-item label="退费" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入费用', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入退费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.other_type'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.pay_way'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 12'>
                      <!-- <div class="input">
                        <a-form-model-item label="执行费" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入执行费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入执行费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div> -->
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.other_type'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.pay_way'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 13'>
                      <div class="input">
                        <a-form-model-item label="评估费" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入评估费', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入评估费' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.other_type'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.pay_way'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                    <div class="li" v-if='i.type == 7'>
                      <div class="input">
                        <a-form-model-item label="其他" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.fee'"
                          :wrapper-col="{ span: 14 }" :rules="[{ required: true, message: '请输入其他费用', trigger: 'blur' }, {
                            validator: Validator.priceVal, trigger: 'blur'
                          }]">
                          <a-input-number v-model="i.fee" style="width:140px;" placeholder='请输入其他费用' :precision="2"
                            :min="0" @input="handlePrice" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="类别" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.other_type'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入类别', trigger: 'blur' }">
                          <a-input v-model="i.other_type" placeholder="请输入类别" :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="input">
                        <a-form-model-item label="支付方式" :label-col="{ span: 9 }"
                          :prop="'refund_fee.' + index + '.pay_way'" :wrapper-col="{ span: 14 }"
                          :rules="{ required: true, message: '请输入支付方式', trigger: 'blur' }">
                          <a-input v-model="i.pay_way" placeholder="请输入支付方式" style="width:140px;"
                            :disabled='openEdit' />
                        </a-form-model-item>
                      </div>

                      <div class="input">
                        <a-form-model-item label="时间" :label-col="{ span: 9 }" :prop="'refund_fee.' + index + '.time'"
                          :wrapper-col="{ span: 14 }" :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                        </a-form-model-item>
                      </div>
                      <div class="delbtns" v-if='!openEdit'>
                        <a-icon type="minus-circle" class="i del" @click='del("refund_fee", index)' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Outs class="background" :outList="form.outList" :money="money" :openEditStatus="openEdit"></Outs>
              <a-form-model-item :wrapper-col="{ span: 24 }" prop="attachments"
                :rules="{ required: false, message: '请上传附件', trigger: 'change' }" style="margin-top:20px;">
                <Upload @isDisabled="parentHandle" :disabled="openEdit" :fList='form.attachments'
                  @getAttachments='lisUpload' @editTitle="editTitle" :edit='openEdit' v-if='!loading' />
              </a-form-model-item>
            </div>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" style="text-align:center;" v-if="!openEdit">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='confirm'>
              <a-button :disabled="disabledShow" type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </drag-modal>
  </div>
</template>
<script>
import Outs from "@/components/outs"
import Proposition from "../stepCredit.json"
import Nscroll from "@/components/nscroll"
import Upload from "@/components/uploads"
import { mapGetters, mapActions } from 'vuex'
import { setInstance, instanceDetail } from "@/server/speed"
import { stepCredit, refundList } from "@/server/api"
import { toTypeName } from "@/assets/js/formData"
import city from "@/assets/js/city.json"
import { citySort } from '@/assets/js/unit'
import { getDirectory } from "@/server/directory"
import Selsee from '@/components/selsee'
import Validator from "@/assets/js/yz.js"
export default {
  name: "paymentPopUp",
  computed: {
    ...mapGetters([
      'litetit',
      'Edit'
    ]),
  },
  props: {
    showModify: {
      type: Boolean,
      default: true
    },
  },
  components: {
    Upload, Nscroll, Selsee, Outs
  },
  data() {
    return {
      Validator,
      options: citySort(city),
      blaxShow: false,
      isAllDis: this.$route.query.t,
      step: this.$store.state.StepLite,
      withList: [],
      oform: false,
      ofIndex: 0,
      form: {
        type: 1,
        fee: [],
        refund_fee: [],
        refund: [],
        attachments: [],
        supp: [],
        accept_file: [],
        outList: [],
        credit: [],
      },
      courtList: [],
      capitalAudit: false,
      smrules: {},
      open: {
        time: null,
        addr: null,
        trial_way: 1, // 1：现场，2：线上
        judge: null,
        judge_tel: null,
        clerk: null,
        clerk_tel: null,
        is_open: 0,
        comment: null,
        id: 0
      },  //开庭信息
      rules: {},
      loading: true,
      openEdit: false,
      disabledShow: false,
      listStatus: false,
      money: '',
    }
  },
  created() {
    // if (this.step == 90 || this.step == 112 || this.step == 117) {
    //   with_debtor({ id: this.$store.state.cause.id }).then(e => {
    //     this.withList = e.list
    //   })
    // }
    // refundList({ cause_id: this.$store.state.cause.id }).then(res => {
    //   const list = res.list.length > 0 ? res.list.map(ele => {
    //     return {
    //       type: ele.type,
    //       fee: ele.fee / 100,
    //       time: ele.time,
    //       files: ele.files,
    //       comment: ele.comment,
    //       audit: ele.audit.length > 0,
    //       filesobj: {
    //         id: ele.files,
    //         origin_name: ele.file_origin_name,
    //         url: ele.file_url
    //       }
    //     }
    //   }) : [
    //     { "type": 1, "fee": '', "time": null, "files": [], "filesobj": {}, comment: "", audit: false },
    //     { "type": 2, "fee": '', "time": null, "files": [], "filesobj": {}, comment: "", audit: false },
    //     { "type": 3, "fee": '', "time": null, "files": [], "filesobj": {}, comment: "", audit: false }
    //   ]
    //   const rr = new Map()
    //   const rlist = list.filter((a) => !rr.has(a.type) && rr.set(a.type, 1))
    //   this.outList = rlist;
    // })
    // stepCredit({ cause_id: this.$store.state.cause.id }).then(e => {
    //   this.credit = this.rPropo(e.list)
    //   this.loading = false;
    // })

    if (this.Edit) {
      this.getFee()
    } else {
      this.loading = false;
    }
  },
  methods: {
    setOpen() {
      this.openEdit = !this.openEdit
      if (!this.openEdit) {
        this.listStatus = true
      }
    },
    PropMoney(credit) {
      if (credit) {
        let i = 0
        credit.filter(s => { return [8, 9, 4, 5].indexOf(s.type) < 0 }).map(ele => {
          i += ele.fee
        })
        return i.toFixed(2)
      } else {
        return 0
      }
    },
    getFee() {
      this.listStatus = true
      this.$nextTick(() => {
        const feeKey = {
          10: ["fee", "give_way", "time", "pay_way", "id", "audit"],
          1: ["fee", "give_way", "time", "pay_way", "id", "audit"],
          2: ["fee", "notice_fee_way", "time", "pay_way", "id", "audit"],
          3: ["fee", "time", "pay_way", "id", "audit", "other_type"],
          4: ["fee", "time", "pay_way", "id", "audit", "other_type"],
          5: ["fee", "time", "id", "audit", "pay_way", "other_type"],
          6: ["fee", "time", "id", "audit", "pay_way", "other_type"],
          7: ["fee", "time", "id", "audit", "pay_way", "other_type"],
          8: ["fee", "time", "id"],
        }
        instanceDetail({ debtor_id: this.$route.params.id, cause_id: this.$store.state.cause.id, instance: this.form.type }).then(e => {
          let type = this.form.type
          this.form = e.detail
          this.form.type = type
          if (this.form.isValue) {
            this.form.credit = this.rPropo(this.form.fee)
            this.form.supp = Object.keys(this.form.supp).map(key => this.form.supp[key])
            this.form.accept_file = Object.keys(this.form.accept_file).map(key => this.form.accept_file[key])
            this.form.supp.map(element => {
              for (let val in element) {
                if (!element[val]) {
                  delete element[val]
                }
              }
              if (element.type * 1 == 4) {
                element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
              }
            })
            this.form.accept_file.map(element => {
              for (let val in element) {
                if (!element[val]) {
                  delete element[val]
                }
              }
              if (element.type * 1 == 4) {
                element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
              }
            })
            let fee = []
            e.detail.fee.map(element => {
              element.fee = element.fee / 100
              element.audit = element.audit === null ? false : true;
              if (element.type != 8) {
                let item = { type: element.type }
                const keyArr = feeKey[element.type]
                if (Array.isArray(keyArr)) {
                  keyArr.forEach(s => {
                    item[s] = element[s]
                  })
                }
                fee.push(item)
              } else {
                this.capitalAudit = element.audit ? true : false
              }
            })
            this.form.fee = fee
            let refund_fee = e.detail.refund_fee.map(element => {
              return {
                ...element,
                fee: element.fee / 100
              }
            })
            // e.detail.refund_fee.map(element => {
            //   element.fee = element.fee / 100
            //   element.audit = element.audit === null ? false : true;
            //   if (element.type != 8) {
            //     let item = { type: element.type }
            //     feeKey[element.type].map(s => {
            //       item[s] = element[s]
            //     })

            //     refund_fee.push(item)
            //   } else {
            //     this.capitalAudit = element.audit ? true : false
            //   }
            // })
            this.form.refund_fee = refund_fee
            this.loading = false
            const list = e.detail.refund.length > 0 ? e.detail.refund.map(ele => {
              return {
                type: ele.type,
                fee: ele.fee / 100,
                time: ele.time,
                files: ele.files,
                comment: ele.comment,
                file_array: ele.file_array.length > 0 ? ele.file_array : [{ file_origin_name: '', file_url: '' }]
              }
            }) : [
              { "type": 1, "fee": '', "time": null, "files": [], file_array: [{ file_origin_name: '', file_url: '' }], "filesobj": {}, comment: "", audit: false },
              { "type": 2, "fee": '', "time": null, "files": [], file_array: [{ file_origin_name: '', file_url: '' }], "filesobj": {}, comment: "", audit: false },
              { "type": 3, "fee": '', "time": null, "files": [], file_array: [{ file_origin_name: '', file_url: '' }], "filesobj": {}, comment: "", audit: false }
            ]
            const rr = new Map()
            const rlist = list.filter((a) => !rr.has(a.type) && rr.set(a.type, 1))
            this.form.outList = rlist;
            this.money = this.PropMoney(this.form.credit)
            // this.$store.dispatch("settime", e.list[0].dkt.update_time)
            // this.Infokey({ key: 'infoList', value: newList })
          } else {
            this.form.outList = [
              { fee: '', file_array: [], files: [], comment: '', time: '', type: 1 },
              { fee: '', file_array: [], files: [], comment: '', time: '', type: 2 },
              { fee: '', file_array: [], files: [], comment: '', time: '', type: 3 }
            ]
            this.loading = false
            // this.listStatus = false  
          }
        })
        this.openEdit = true;
      })
    },
    rPropo(Arr) {
      let newArr = []
      Object.keys(Proposition).map(item => {
        let isInclude = Arr.some(it => {
          return it.type == item
        })
        if (isInclude == false) {
          newArr.push({
            type_title: Proposition[item],
            type: item * 1,
            fee: 0
          })
        } else {
          newArr.push(Arr.filter(ele => { return ele.type == item })[0])
        }
      })
      return newArr
    },
    getphaseChange(e) {
      this.type = e.target.value
      this.form.credit = []
      this.form.outList = []
      this.getFee()
    },
    parentHandle(data) {
      this.disabledShow = data
    },
    handlePrice(value, index) {
      if (value < 0) {
        this.$set(this.form.fee[index], 'fee', '');
        this.$set(this.form.refund_fee[index], 'refund_fee', '');
        return;
      }
      const formatted = Validator.formatAmount(value);
      this.$set(this.form.fee[index], 'fee', formatted ? Number(formatted) : '');
      this.$set(this.form.refund_fee[index], 'refund_fee', formatted ? Number(formatted) : '');
    },
    toTypeName,
    seachCourtList(val) {      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : '';
      getDirectory({ province_id: province_id, city_id: city_id, area_id: area_id }).then(e => {
        this.courtList = e.list
      })
    },
    setpType(type) {
      this.form.type = type;
      // if (!this.form.court) {
      //   this.form.appellor = []
      //   this.form.appellee = []
      // }
    },
    editsm(item, index) {
      this.open = JSON.parse(JSON.stringify(item))
      this.ofIndex = index
      this.blaxShow = true;
      this.oform = true;
    },
    canopen() {
      this.oform = false;
      this.blaxShow = false;
      this.open = {}
    },
    isopencg(val) {
      if (val == 1) {
        this.open.comment = null
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    formType() {
      if (this.$store.state.StepLite == 40) {
        return 1
      } else {
        // if (this.$store.state.nineBool) { //false被告    true 原告
        //   return 2
        // } else {
        //   return 3
        // }
        return 2
      }
    },
    saveOpen() {
      this.$refs.smforms.validate(valid => {
        if (valid) {
          if (this.oform) {
            this.form.open[this.ofIndex] = JSON.parse(JSON.stringify(this.open))
            this.open.comment = null
            this.oform = false;
            this.$refs.smforms.resetFields()
            this.blaxShow = false;
          } else {
            let form = JSON.parse(JSON.stringify(this.open))
            if (form.id) {
              form.id = 0
            }
            this.form.open.push(form)
            this.open.comment = null
            this.$refs.smforms.resetFields()
          }
        }
        else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see1',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove'
    }),
    sAdd(type, lite) {
      let smForm = {
        type: type
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    plusAdd(title, type) {
      let smForm = {
        type: type,
        id: 0
      }
      if (title == 'fee') {
        this.form.fee.push(smForm)
      } else {
        this.form.refund_fee.push(smForm)
      }

    },
    async copydel(index) {        //删除进度
      // await this.Newdel({ index: index, formKey: this.formKey, valkey: "dkt" }).then(e => {
      //   this.form = JSON.parse(JSON.stringify(e));
      //   this.loading = false;
      // })
    },
    copyNew() {        //新增复制进度
      this.loading = true;
      let copyItem = {
        cause_id: null,
        id: null,
        supp: [],       //补充材料数组
        accept_file: [],
        type: this.formType(),
        open: [],
        fee: [],
        files: [],
        title: this.litetit
      }
      this.capitalAudit = false;
      this.addNew(copyItem).then(index => {
        this.form = {
          type: this.formType(),
          supp: [],       //补充材料数组
          accept_file: [],
          refund: [],
          refund_fee: [],
          open: [],
          fee: [],
          blaxShow: false,
          attachments: []
        }
        this.loading = false;
      })
    },
    // async see(index,phase) {        //查看切换 审批
    //   this.loading = true;
    //   this.seeInfo({ index: index, formKey: this.formKey, valkey: "dkt" }).then(e => {
    //     this.capitalAudit = e.audit ? true : false;
    //     this.form = JSON.parse(JSON.stringify(e));

    //     this.loading = false;
    //   })
    // },
    confirm() {
      console.log(this.form.attachments);
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          form.attachments = Array.isArray(form.attachments)
            ? form.attachments.filter(ele => ele !== null && ele !== undefined)
            : [];
          if (form.attachments.length > 0) {
            form.attachments = form.attachments.map(ele => {
              const baseObj = typeof ele === 'string'
                ? { upload_id: ele, title: '', url: '' }
                : ele || {};
              return {
                upload_id: String(baseObj.upload_id || baseObj.upload_id === 0 ? baseObj.upload_id : ele),
                title: String(baseObj.title || ''),
                url: String(baseObj.url || '')
              };
            });
          }
          form.supp.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          form.accept_file.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          form.fee.map(ele => {
            ele.fee = ele.fee * 100
          })
          form.refund_fee.map(ele => {
            ele.fee = ele.fee * 100
          })
          form.outList.map(ele => {
            ele.fee = ele.fee * 100
          })
          form.refund = form.outList
          form.cause_id = this.$store.state.cause.id
          delete form.isAudit
          delete form.isValue
          delete form.credit
          delete form.outList
          if (this.Edit) {      //修改
            setInstance(form).then(e => {
              this.$message.success({ content: '修改成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    tabdel(index) {
      this.form.open.splice(index, 1)
    },
    del(title, index) {
      if (title == 'fee') {
        this.form["fee"].splice(index, 1)
      } else {
        this.form["refund_fee"].splice(index, 1)
      }
    },
    sdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    reset() {
      this.$store.dispatch('openkey', { key: 'paymentPopUp', by: false })
      // this.reMove().then(e => {
      //   this.$refs.forms.resetFields();

      // })
    },
    lisUpload(fileList) {
      if (fileList) {
        this.form.attachments = fileList
      }
    },
    editTitle(file) {
      console.log('fileeeee', file, this.form.attachments);
      this.form.attachments = this.form.attachments.map((ele) => {
        return {
          ...ele,
          title: file
        }
      })
      console.log('this.form.attachments', this.form.attachments);
    }
  }
}
</script>
<style lang="less">
.fourlist .ant-calendar-picker {
  min-width: auto !important;
}

.bjlabel .ant-form-item-label {
  text-align: left;
  //   width: 80px;
}
</style>
<style lang="less" scoped>
.listcard {
  border-radius: 4px;
  padding: 20px 0 10px;
  box-sizing: border-box;

  .title {
    font-size: 1.125rem;
    font-weight: 500;
    margin-bottom: 10px;
  }
}

.listnone {
  // padding: 0;
}

.ilikecon {
  max-height: 400px;
  overflow: auto;
  margin-bottom: 20px;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 20px;
  border-radius: 8px;

  .ant-form-item {
    margin: 0 !important;
  }

  /deep/ .ant-form-item-label {
    text-align: left !important;
  }

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }
}

.mr20 {
  margin-right: 12px;
  width: 100px;
  padding: 0;
}

.fourlist {
  overflow: auto;
  margin-bottom: 10px;
  border-radius: 8px;
  // padding: 0 10px;

  & .dil:nth-child(1) {
    .li {
      padding-top: 1.25rem;
    }
  }
}

.htit {
  font-size: 1rem;
  color: #333;
  line-height: 40px;
  margin: 10px 0;
}

.dul {
  margin: 0 2px;

  .li {
    // border-radius: 4px;
    background: #f3f6fb;
    display: flex;

    .input {
      width: 33.3%;
    }

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  .dil {
    .li {
      .input {
        width: 25%;

        &:nth-last-child(1) {
          padding-right: 8px;
        }
      }
    }
  }
}

.nbg {
  .li {
    background: none;
  }
}

.blax {
  width: 100%;
  background: #f3f6fb;

  .dul {
    padding: 0 20px;
  }

  .li {
    display: flex;
    width: 100%;

    .input {
      flex: 1;
      max-width: 30%;
      padding-right: 20px;
    }

    // .input {
    //   max-width: 30%;
    // }
  }

  .ndul {
    .li {
      .input {
        flex: 1;
        max-width: 33.3%;

        &:nth-last-child(1) {
          padding-right: 0;
        }
      }
    }
  }
}

.table {
  table {
    width: 100%;
  }
}

.morebar {
  display: flex;
  margin-bottom: 10px;
  height: 40px;
  align-items: center;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}

/deep/ .ant-form-item {
  margin-bottom: 12px;
}

.li .delbtns {
  width: 5%;
  display: flex;
  font-size: 1.25rem;
  justify-content: space-between;
  padding-right: 20px;
  height: 40px;
  align-items: center;
  color: #f00;
}

.principal {
  font-size: 0.875rem;
  color: #000000D9;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.lawsuit {
  font-size: 14px;
  color: #000000D9;
  margin: 20px 0 10px;
}

.ninputs {
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.875rem;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  width: 200px;
  margin-top: 5px;
}

.licter {
  overflow: hidden;
  margin-bottom: 12px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: right;
    color: #333;
    line-height: 30px;
    margin-right: 20px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}

@import '../index.css';
</style>